import { FIQAssist } from "../app"
import { Directive } from "@fiqas/angular-utils";
import { KeyCodes, KeyboardEventCode } from "@fiqas/utils";

@Directive({
    selector: 'onlyNumeric',
    module: FIQAssist
})
export class OnlyNumeric {

    constructor() {}

    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes): void {

        element.on('keypress', function (event: any) {
            if (event.which >= 48 && event.which <= 57
                || event.which === 0 && event.charCode === 0
                || event.keyCode === KeyCodes.backspace
                || event.keyCode === KeyCodes.delete
                || event.keyCode === KeyCodes.dash
                || event.keyCode === KeyCodes.subtract
                || event.code === KeyboardEventCode.backspace
                || event.code === KeyboardEventCode.delete
                || event.code === KeyboardEventCode.dash
                || event.code === KeyboardEventCode.subtract
                || event.key === '-'
               ) {
                // to allow numbers
                return true;
            } else {
                // to stop others
                event.preventDefault();
                return false;
            }
        });
    }
}
